import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function Stats({classes=""}) {
  return (
    <>
     <style>
        {`
            .stats-container { margin-top: -70px; }
            .stats-counter { padding: 34px 30px; border-radius: 10px; overflow: hidden; color: #fff !important; background-size: cover; position: relative; z-index: 99; }
            .stats-counter h3, .stats-counter p{ color: #fff !important;}
            .stats-count { font-size: 24px; font-family: var(--f700); margin-bottom: 5px; }
            .stats-count span { margin-right: 6px; }
            .stats-content h3 { font-size: 30px; margin-bottom: 10px; }
            .stats-content { max-width: 460px; }
            @media screen and (max-width:1199.98px) { }
            @media screen and (max-width:991.98px) {
                .stats-content h3 { font-size: 27px; }
            }
            @media screen and (max-width:767.98px) { }
        `}
     </style>
       <div className={`section-padding stats-container ${classes}`}>
           <Container >
              <Row className='gy-4' >
                <Col md={6}>
                    <div className="stats-counter"  data-aos="fade-up"  style={{backgroundImage: "url('../assets/images/videoCta/counter-bg-1.jpg')"}}>
                        <div className="stats-count"><span>9</span>+</div>
                        <div className="stats-content">
                            <h3>Years Experience</h3>
                            <p>To succeed, every software solution must be deeply integrated 
                                into the existing tech environment..</p>
                        </div>
                    </div>
                </Col>
                <Col md={6}>
                    <div className="stats-counter"  data-aos="fade-up"  style={{backgroundImage: "url('../assets/images/videoCta/counter-bg-1.jpg')"}}>
                        <div className="stats-count"><span>654</span>+</div>
                        <div className="stats-content">
                            <h3>Clients Worldwide</h3>
                            <p>Delivering exceptional global service with tailored solutions to meet unique client needs across the world.</p>
                        </div>
                    </div>
                </Col>
              </Row>
           </Container>
       </div>
    </>
  )
}

export default Stats